import React, { FC, useMemo } from 'react'
import { NormalizedModel } from '@player/types';

import { clsx } from 'clsx';
import { Avatar } from '@ui/avatar/avatar';

import { CheckCircleIcon } from '@ui/icons/material/CheckCircle';
import { Skeleton } from '@ui/skeleton/skeleton';

export interface ModelItemProps {
    model: NormalizedModel
    selected: NormalizedModel[]
    onSelect: (artist: NormalizedModel) => void
    showKey?: 'display_name' | 'name' | 'description'
}

export const ModelItem: FC<ModelItemProps> = ({ model, selected, onSelect, showKey }) => {
    const isSelected = useMemo(() => selected.find(a => a.id === model.id), [selected])

    return (
        <button
            className={clsx(
                'flex mb-2 last-of-type:mb-0 items-center gap-10 px-10 py-5 w-full',
                isSelected ? 'bg-primary/10' : 'hover:bg-hover'
            )}
            onClick={() => onSelect?.(model)}
        >
            <Avatar src={model.image} size="sm" label={model.name} />
            {model[showKey || 'display_name'] || model.name}

            {isSelected && (
                <CheckCircleIcon size="xs" className="text-accent ml-auto" />
            )}
        </button>
    )
}

export const ModelItemSkeleton = () => (
    <div className="flex mb-2 last-of-type:mb-0 items-center gap-10 px-10 py-5 w-full">
        <Skeleton size="w-24 h-24" variant="avatar" className="w-24 h-24 shrink-0" />
        <Skeleton variant="text" />
    </div>
)
